/*
 * Copyright (c) 2021.  Blacksheepz media B.V.
 * https://www.blacksheepz-media.com
 * Ramon van Ophuizen
 */

import React, {useState} from 'react';
import {withRouter } from 'react-router-dom';
import {withTranslation} from 'react-i18next';

import {
    TextField,
    Grid,
    FormGroup
} from "@material-ui/core";
import PhotoComponent from "../Photo/PhotoComponent";

import {CREATE_MESSAGE} from '../../queries';
import {useMutation} from '@apollo/client';
import {useThemeData} from '../../context/ThemeDataContext'
import GeneralButton from "../Buttons";
import GeneralText from "../Fonts";

function LoginShareFormComponent(props) {
    const {site_id} = useThemeData().themeData.site;
    const {
        primary_color_2
    } = useThemeData().themeData.site.theme;
    const [validated, setValidated] = useState(false);
    const [Contact, setContact] = useState({
        login_name: localStorage.getItem('login_name'),
        firstname_sender: '',
        send_email_to: '',
        subject: '',
        message: ''
    });
    const [validation, setValidation] = useState({
        firstname_sender: "notActive",
        send_email_to: "notActive",
        subject: "notActive",
        message: "notActive"
    });

    console.log(validated);

    console.log(validation);


    const handleChange = (event) => {

        const {name, value} = event.target;
        const emailRegex = new RegExp("[^\\.\\s@:](?:[^\\s@:]*[^\\s@:\\.])?@[^\\.\\s@]+(?:\\.[^\\.\\s@]+)+(?:\\.[^\\.\\s@]+)*");
        if (value === '') {
            setValidation(prevState => ({...prevState, [name]: false}));
        } else {
            if (name === 'send_email_to') {
                if (emailRegex.test(value)) {
                    setValidation(prevState => ({...prevState, [name]: true}));
                } else {
                    setValidation(prevState => ({...prevState, [name]: false}));
                }
            } else {
                setValidation(prevState => ({...prevState, [name]: true}));
            }
        }
        setContact(prevState => ({...prevState, [name]: value}));
    }

    const onCompleted = () => {
        props.setCompleted(true);
    }

    const [createMessage,
        {loading: loadingContactMessage, error: errorContactMessage}]
        = useMutation(CREATE_MESSAGE, {
            onCompleted: onCompleted
        }
    );

    const handleSubmit = (event) => {
        const form = event.currentTarget;
        if (form.checkValidity() === false) {
            event.preventDefault();
            event.stopPropagation();
        } else {
            event.preventDefault();
            createMessage({
                variables: {
                    user_id: props.user_id,
                    site_id: site_id,
                    photo_id: localStorage.getItem("photo_id"),
                    username: Contact.login_name,
                    type: 'inlogdoorsturen',
                    subject: Contact.subject,
                    firstname_sender: Contact.firstname_sender,
                    send_email_to: Contact.send_email_to,
                    message: Contact.message,
                }
            });
        }
       setValidated(true);
    }

    const goBackHome = () => {
        let location = {
            pathname: `/shoppage/photo_id/${localStorage.getItem("photo_id")}`
        }
        props.history.push(location);
    }


    if (loadingContactMessage) return <p>{props.t('Loading...')}</p>
    if (errorContactMessage) return <p>{props.t('Looks like we have a problem...')}</p>
    return (
        <Grid container>
            <Grid item xs={6} sm={6} md={6} lg={6} xl={6}>
                <Grid container direction="row">
                <GeneralText
                    style={{color: primary_color_2}}
                    variant="h6"
                    gutterBottom={true}
                >
                    {props.t('Share login')}
                </GeneralText>
                </Grid>

                <form className="contact-text" onSubmit={handleSubmit}>
                    <p>{props.t('Please fill in this form to share your login.')}</p>


                    {/*<Form.Label> {props.t('Sender')}</Form.Label>*/}
                    <FormGroup>
                    <TextField
                        type="name"
                        variant="outlined"
                        name="firstname_sender"
                        margin="normal"
                        // className={validation.firstname_sender === true ? "form-control is-valid" : validation.firstname_sender === false ? "form-control is-invalid" : null}
                        value={Contact.firstname_sender}
                        placeholder={props.t('Enter firstname')}
                        onChange={(e) => handleChange(e)}
                        required/>


                    {/*<Form.Label>{props.t('Send to')}</Form.Label>*/}
                    </FormGroup>

                    <FormGroup>
                    <TextField
                        type="email"
                        variant="outlined"
                        name="send_email_to"
                        margin="normal"
                        // className={validation.send_email_to === true ? "form-control is-valid" : validation.send_email_to === false ? "form-control is-invalid" : null}
                        value={Contact.send_email_to}
                        placeholder={props.t('Enter email address(es)')}
                        onChange={(e) => handleChange(e)}
                        multiple
                        required/>

                    </FormGroup>
                    <FormGroup>
                    <TextField
                        type="text"
                        variant="outlined"
                        name="subject"
                        margin="normal"
                        value={Contact.subject}
                        // className={validation.subject === true ? "form-control is-valid" : validation.subject === false ? "form-control is-invalid" : null}
                        placeholder={props.t('Subject')}
                        onChange={(e) => handleChange(e)}
                        required/>

                    </FormGroup>
                    <FormGroup>
                    {/*<Form.Label>{props.t('Text')}</Form.Label>*/}
                    <TextField
                        id="message"
                        name="message"
                        label={props.t('Enter text')}
                        margin="normal"
                        multiline={true}  // Fixed line
                        rows={5}
                        className="mb-2"
                        variant="outlined"
                        autoFocus
                        fullWidth
                        onChange={(e) => handleChange(e)}
                    />
                    </FormGroup>

                    <GeneralButton
                        onClick={goBackHome}
                        className="btn btn-light btn-margin">
                        {props.t('Back to the Shop')}
                    </GeneralButton>
                    <GeneralButton
                        className="btn btn-light btn-margin"
                        type="submit">
                        {props.t('Send')}
                    </GeneralButton>

                </form>
            </Grid>
            <Grid item xs={6} sm={6} md={6} lg={6} xl={6}>

                <p>{props.t('Below you can see the photo you are sharing.')}</p>

                <PhotoComponent
                    site_id={site_id}
                    folder_id={localStorage.getItem("folder_id")}
                    photo_id={localStorage.getItem("photo_id")}
                    photo_file_name={localStorage.getItem("photo_file_name")}
                    type={0}/>
            </Grid>
        </Grid>

    );

}

export default React.memo(withRouter(withTranslation('photoLoginShare')(LoginShareFormComponent)));
